import { createContext, useContext, Children, cloneElement, React, useState, useEffect, useRef, Fragment } from "react";
import { Page, Text, View, Document, StyleSheet, PDFViewer, Font, Image, Svg, BlobProvider, Link, Line, usePDF } from '@react-pdf/renderer';
// import MicrosoftBlack from './MicrosoftBlack.ttf';
// import MicrosoftBlack from './kaiu.ttf';
import FistPageTW from '../Pictures/front.png';
import FistPageEN from '../Pictures/front-en.png';
import LastPageTW from '../Pictures/back.png';
import LastPageEN from '../Pictures/back-en.png';
import LOGO from '../Pictures/logo-inner.png';
import LOGOPNG from '../Pictures/logo.png';

import Header_1 from '../Pictures/page-1-header.jpg';
import Header_2 from '../Pictures/page-2-header.jpg';
import Header_3 from '../Pictures/page-3-header.jpg';
import Header_4 from '../Pictures/page-4-header.jpg';
import Header_5 from '../Pictures/page-5-header.jpg';
import Males from '../Pictures/males.png';
import { Table, TableBody, TableHeader, TableCell, DataTableCell } from '@david.kucsai/react-pdf-table';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import Stamp from '../Pictures/stamp.jpg';
import PF from "../_Services/publicFunction";
import Qs from "qs";
import _, { omit, pick } from 'lodash'
// import Noto from '../Pictures/NotoSansTC-Regular.otf';
import NotoBold from '../Pictures/NotoSansTC-Bold.otf';
import NotoBold2 from '../Pictures/NotoSansSC-Bold.ttf';    //簡體

// import Noto from '../Pictures/NotoSansMonoCJKtc-Regular.ttf';        //最ＯＫ

// import Noto from '../Pictures/NotoSansSC-Regular3.ttf';        //最ＯＫ

import Noto from '../Pictures/NotoSansTC-Regular.otf';        //最ＯＫ
import Noto2 from '../Pictures/Noto Sans SC20260915.ttf';        //簡體
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl, IntlProvider } from "react-intl";

// import Noto from '../Pictures/test.ttf';        //最ＯＫ


// import Noto from '../Pictures/NotoSansCJKtc-Regular.otf';
// import Noto from '../Pictures/NotoSansTC-Regular2.otf';
// import Noto from '../Pictures/NotoSansMonoCJKtc-Regular2.otf';        
// import Noto from '../Pictures/SourceHanSansTWHK-Regular.otf';        
// import Noto from '../Pictures/notosanstc-regular2-webfont.woff';        
// import Noto from '../Pictures/Roboto-Regular.ttf';
// import Noto from '../Pictures/SourceHanSerifTW-Regular.otf';
// import Noto from '../Pictures/SweiSansCJKtc-Regular.ttf';
// import NotoBold from '../Pictures/Roboto-Bold.ttf';
// import Noto from '../Pictures/NotoSansTC-Regular3.ttf';        //最ＯＫ

import { color, display } from "@mui/system";
import { wait } from "@testing-library/user-event/dist/utils";
// var fontkit = require('fontkit')

// open a font synchronously
// var font = fontkit.openSync(NotoBold)
// //註冊中文：微軟正黑體
// Font.register({
//     family: 'MicrosoftBlack',
//     src: MicrosoftBlack,
// });


Font.register({
    family: 'Noto',

    fonts: [
        // {
        //     src: Noto,
        //     fontWeight: 'normal',
        // },
        // {
        //     src: NotoBold,
        //     fontWeight: 'bold',
        // },
        {
            src: Noto2,
            fontWeight: 'normal',
        },
        {
            src: NotoBold2,
            fontWeight: 'bold',
        },
        // {
        //     src: 'https://fonts.gstatic.com/ea/notosanstc/v1/NotoSansTC-Regular.otf',
        // },
        // {
        // src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
        // fontStyle: 'italic',
        // },
    ],
});
//中文自動換行

// Font.registerHyphenationCallback(word => [word]);
// Font.registerHyphenationCallback(word => {
//     console.log(word)
//     console.log([word])
//     console.log(Array.from(word).flatMap((char) => [char, '']))
//     return [word]
// });




const Context = createContext();

export function ProvidePageReferences({ children }) {
    // use ref so we don't create a new map every render
    const ref = useRef();
    if (!ref.current) {
        ref.current = new Map();
    }
    return <Context.Provider value={ref.current}>{children}</Context.Provider>;
}

export function usePageReferences() {
    return useContext(Context);
}

// use this as a component in the react-pdf document tree
export function PageReference({ id }) {
    const references = usePageReferences();
    return references && id ? (
        <View
            wrap={false}
            render={({ pageNumber }) => {
                references.set(id, pageNumber);
            }}
        />
    ) : null;
}
function Toc({ items, subItems }) {
    const references = usePageReferences();
    // console.log(subItems)
    // console.log(items)
    return (
        <View style={[styles.section, { marginTop: 0 }]} >
            {items.map((item, index) => {
                const { id, title, i18n } = item;
                return (
                    <>
                        <View key={index} style={[styles.row, { padding: 8, borderTop: index !== 0 ? "2 solid #dcdcdc" : "" }]} >
                            <Link src={`#${id}`} style={{ color: "#ff8b3c", textDecoration: 'none', fontWeight: 600, fontSize: 14 }}>
                                <Text>0{index + 1} {" - "}{i18n}</Text>
                            </Link>
                            <View style={[styles.line, { borderBottomColor: "white" }]} />
                            <Text src={`#${id}`}
                                render={() => {
                                    const page = references.get(id);
                                    return page == null ? '##' : String(page);
                                }}
                            />
                        </View>
                        {subItems[id]?.length > 0 ? subItems[id].map((prop, i) => {
                            const { id2, title2, i18n2 } = prop;
                            // console.log(id2);
                            // 
                            return (
                                <View key={i} style={[styles.row, { fontSize: 12, paddingLeft: 10, paddingRight: 8 }]}>
                                    <Link src={`#${id2}`} style={{ color: "#000000", textDecoration: 'none', paddingLeft: 30 }}>
                                        <Text>{i18n2}</Text>
                                    </Link>
                                    <View style={styles.line2} />
                                    <Text src={`#${id2}`}
                                        style={{ fontSize: 14 }}
                                        render={() => {
                                            const page = references.get(id2);
                                            return page == null ? '##' : String(page);
                                        }}
                                    />
                                </View>
                            )

                        }) : null}
                    </>
                );
            })}
        </View>
    );
}

// function genItems(count) {
//     const items = [];
//     for (let i = 0; i < count; i++) {
//         items.push({
//             id: `item-${i}`,
//             title: `Item ${i}`,
//         });
//     }
//     return items;
// }

// function ItemContent({ item, break: pageBreak }) {
//     const { id, title } = item;
//     return (
//         <View break={pageBreak} >
//             <Text id={id}>{title}</Text>
//             <PageReference id={id} />
//             <Text
//                 render={({ pageNumber, totalPages }) =>
//                     `${pageNumber} / ${totalPages}`
//                 }
//             />
//         </View>
//     );
// }

// function newPage(chance) {
//     return Math.random() < chance;
// }
// Create styles
const styles = StyleSheet.create({
    //作用於內容頁
    page: {
        // flexDirection: 'row',
        fontFamily: 'Noto',
        backgroundColor: 'white',
        // paddingBottom: 0
        borderColor: '#22618F',
        borderWidth: 0,
        paddingBottom: 30,
        paddingTop: 70,
        // paddingLeft: 30,

    },
    //作用於首頁跟頁碼跟尾頁
    page2: {
        // flexDirection: 'row',
        fontFamily: 'Noto',
        backgroundColor: 'white',
        // paddingBottom: 0
        borderColor: '#22618F',
        borderWidth: 0,
        paddingBottom: 50,

    },
    section: {
        margin: 10,
        padding: 10,
        paddingLeft: 55,
        paddingRight: 55,
        // flex: 1,
        // maxWidth: 1050
        // flexGrow: 1,
    },
    imgHeader: {
        width: 130,
        padding: 20,
        float: 'left'
    },
    //大項目的圖片，ex 01
    imgTitle: {
        // padding: 0,
        // left: 0,
        // margin: 0,
        position: 'absolute',
        zIndex: -1,
        top: -10,   //緊接header因為page有paddingTop
        width: '100%'
    },
    txtHeader: {
        paddingBottom: 50,
    },
    txtNo1: {
        fontSize: 40,
        // fontWeight: "bold",
        color: "#ff8b3c",
    },
    txtNo2: {
        fontSize: 20,
        fontWeight: "bold"
    },
    txtTitle: {
        paddingTop: 0,
        top: 0,
        paddingLeft: 55,
        paddingBottom: 50,

    }
    ,
    header: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: 60,
        // backgroundColor: '#3f51b5',
        backgroundColor: '#fff8ea',
        display: 'flex',
        flexDirection: "row",
        justifyContent: "center",
        // color: '#FFFFFF',
        // opacity: 0.8,
        // fontWeight: "bold"
    },
    header01: {
        padding: 5,
        paddingLeft: 5,
        paddingTop: 13,
        borderLeft: '1px solid #dcdcdc',
        fontSize: 10,
        // justifyContent: "center"
    },
    //尾部頁碼
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },
    table: {
        // display: "table",
        // width: "auto",
        // borderStyle: "solid",
        // borderWidth: 1,
        // borderRightWidth: 0,
        // borderBottomWidth: 0
    },
    tableRow: {
        // margin: "auto",
        // flexDirection: "row"
    },
    tableCol: {
        width: "25%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableCell: {
        margin: "auto",
        marginTop: 5,
        fontSize: 10,
    },
    TableBorder: {
        padding: 5,
        textAlign: "left",
        fontSize: 8,
        borderWidth: 0,
        borderTopWidth: 0,

    }, column: {
        flexDirection: 'column',
    },
    row: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-start',
    },
    line: {
        flexGrow: 1,
        borderBottomStyle: 'dotted',
        borderBottomWidth: 1,
        borderBottomColor: '#000000',
        marginHorizontal: 2,
        height: 11,
    },
    line2: {
        flexGrow: 1,
        borderBottomStyle: 'dashed solid',
        borderBottomWidth: 1,
        borderBottomColor: 'white',
        marginHorizontal: 2,
        height: 11,
    },
    txtOverView: {
        fontSize: 12, paddingTop: 10,
        width: 350, textAlign: 'left',
        paddingLeft: 50
    },
    txtOverView2: {
        fontSize: 12, paddingTop: 10,
        width: 145, textAlign: 'left'
    },
    txtOverView3: {
        fontSize: 12, paddingTop: 10,
        width: 200, textAlign: 'left'
    },
    // page: {
    //     textAlign: 'right',
    //     textOverflow: 'hidden',
    // },
});


// const TableContext = createContext({});
const ContentHeader = props => {
    const { Profile } = props;
    const intl = useIntl();
    return (
        <View style={styles.header} fixed >
            <View style={{ textAlign: 'left', justifyContent: "flex-start", width: 140 }}>
                <Image src={LOGO} style={styles.imgHeader} ></Image>
            </View>
            <View style={[styles.header01, { width: 80 }]} >
                <Text style={{ paddingBottom: 5 }}>{intl.formatMessage({ id: "Name" })}: {Profile.UserName}</Text>
                <Text>
                    {intl.formatMessage({ id: "Gender" })}:{Profile.sex ? intl.formatMessage({ id: Profile.sex }) : ""}
                </Text>
            </View>
            <View style={[styles.header01, { width: 100 }]} >
                <Text style={{ paddingBottom: 5 }}>{intl.formatMessage({ id: "Birth" })}: {Profile.birthday}</Text>
                <Text>{intl.formatMessage({ id: "Age" })}: {Profile.age}</Text>
            </View>
            <View style={[styles.header01, { width: 130 }]} >
                <Text style={{ paddingBottom: 5 }}>{intl.formatMessage({ id: "ID." })}: {Profile.PersonalId}</Text>
                {/* <Text style={{ paddingBottom: 5, fontFamily: undefined }}>身分證字號: {Profile.PersonalId}</Text> */}

                {/* <Text>手機: {Profile.sogi}</Text> */}
            </View>
            <View style={[styles.header01, { width: 110 }]} >
                <Text style={{ paddingBottom: 5 }}>{intl.formatMessage({ id: "Date" })}: {Profile.checkdate}</Text>
                <Text>{intl.formatMessage({ id: "No." })}: {Profile.chart}</Text>
            </View>
        </View>
    )
}
// const Table = ({ children, sizes }) => (
//     <TableContext.Provider value={{ sizes }}>
//         <View style={{ borderBottom: 1, borderRight: 1 }}>{children}</View>
//     </TableContext.Provider>
// );

// const Row = ({ children }) => {
//     const { sizes } = useContext(TableContext);
//     if (!sizes) throw Error("add sizes prop to Table component");
//     return (
//         <View style={{ flexDirection: "row" }}>
//             {Children.map(children, (child, index) =>
//                 cloneElement(child, { size: sizes[index] })
//             )}
//         </View>
//     );
// };

// const Cell = ({ children, size }) => (
//     <View
//         style={{
//             padding: "5 10",
//             flex: `0 0 ${size}%`,
//             borderTop: 1,
//             borderLeft: 1,
//         }}
//     >
//         <Text>{children}</Text>
//     </View>
// );
// Create Document Component


const MyDocument = (props) => {
    // const [instance, update] = usePDF({ document });
    // console.log(instance)
    const { items, Profile, Array03, Array04, Array06, Array05, PicObj, Array02, subItems } = props;
    // console.log(Array02)
    // console.log(Array03)
    // console.log(Array04)
    // console.log(Array05)
    // console.log(Array06)
    // console.log(Profile)
    // console.log(PicObj)
    //二欄式錯誤清單
    const ErrItem = ['7008', '7010', '7011', '7012', '7013', '7014', '7015', '7016', '7023', '7028', '7029', '7030', '7031', '7032', '7033', '7034', '7035', '7036', '7037', '7038', '7039', '7040', '7049', '7050', '7051', '7052', '7053', '7054', '7055', '7057', '7058', '7070', '7076', '7092', '7097', '7098', '7164'];
    const FirstPageInfo = ['2008', '2031', '2013'];
    // let ErrArray02_1 = _.orderBy(Array02.filter(x => !ErrItem.includes(x.ItemNo)), ['OrderIndex'], ['asc']);
    let ErrArray02_1 = _.orderBy(Array02.filter(x => !ErrItem.includes(x.ItemNo)), x => new Number(x.OrderIndex), ['asc']);
    // let ErrArray02_1 = Array02.filter(x => !ErrItem.includes(x.ItemNo))
    // console.log(ErrArray02_1)




    const intl = useIntl();

    return (
        < >
            <Page size="A4" style={styles.page} key={"01"} >
                <PageReference id={'01'} />
                <ContentHeader Profile={Profile} {...props} />
                <View style={styles.txtHeader} id={'01'} >
                    <Image src={Header_1} style={styles.imgTitle} ></Image>
                </View>
                <View style={styles.txtTitle}>
                    <Text style={styles.txtNo1}>01</Text>
                    <Text style={styles.txtNo2}>基本資料</Text>
                    <Text style={{ fontSize: 10 }}>Basic Assessment</Text>
                </View>
                <View style={[styles.section, { paddingRight: 60 }]}>
                    <Text>{intl.formatMessage({ id: "Personalinfo" })}</Text>
                    <Table
                        style={{ padding: 0 }}
                        data={[
                            { firstName: intl.formatMessage({ id: "Name" }), lastName: Profile.UserName, dob: intl.formatMessage({ id: "ID." }), country: Profile.PersonalId },
                            { firstName: intl.formatMessage({ id: "BirthDate" }), lastName: Profile.birthday, dob: intl.formatMessage({ id: "ExamNo" }), country: Profile.chart },
                            { firstName: intl.formatMessage({ id: "Age" }), lastName: Profile.age, dob: intl.formatMessage({ id: "ExamDate" }), country: Profile.checkdate },
                            {
                                firstName: intl.formatMessage({ id: "Gender" }),
                                lastName: Profile.sex ? intl.formatMessage({ id: Profile.sex }) : "", // 避免 undefined
                                dob: "",
                                country: ""
                              }
                        ]}
                    >
                        <TableHeader textAlign={"center"}
                            includeBottomBorder={false}
                            includeTopBorder={false}
                            includeRightBorder={false}
                            includeLeftBorder={false}
                            style={{ borderBottom: "2pt solid #a76f1f" }}
                        >

                        </TableHeader>
                        <TableBody
                            style={{ borderBottom: "1pt solid #a76f1f", borderTop: "1 solid #a76f1f" }}
                            includeBottomBorder={false}
                            includeTopBorder={false}
                            includeRightBorder={false}
                            includeLeftBorder={false}
                        >
                            <DataTableCell getContent={(r) => r.firstName} style={{ fontSize: 12, backgroundColor: "#e1deeb", textAlign: "center", justifyContent: "center", borderWidth: 0, borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }} />
                            <DataTableCell getContent={(r) => r.lastName} style={{ fontSize: 12, backgroundColor: "#f8f7fa", justifyContent: "center", paddingLeft: 10, padding: 5, borderWidth: 0, borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }} />
                            <DataTableCell getContent={(r) => r.dob.toLocaleString()} style={{ fontSize: 12, backgroundColor: "#e1deeb", textAlign: "center", justifyContent: "center", borderWidth: 0, borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }} />
                            <DataTableCell getContent={(r) => r.country} style={{ fontSize: 12, backgroundColor: "#f8f7fa", justifyContent: "center", paddingLeft: 10, borderWidth: 0, borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }} />

                        </TableBody>
                    </Table>

                </View>
                {PF.multiFilter(Array03, { ItemNo: FirstPageInfo }).length > 0 ?
                    <View style={[styles.section, { paddingRight: 60 }]}>
                        <Text style={{}} >{intl.formatMessage({ id: "AssessmentInfo" })}</Text>
                        <Table
                            style={{ padding: 0 }}
                            data={PF.multiFilter(Array03, { ItemNo: FirstPageInfo })}
                        >
                            <TableHeader textAlign={"center"}
                                includeBottomBorder={false}
                                includeTopBorder={false}
                                includeRightBorder={false}
                                includeLeftBorder={false}
                                style={{ borderBottom: "2pt solid #a76f1f" }}
                            >
                            </TableHeader>
                            <TableBody
                                style={{ borderBottom: "1pt solid #a76f1f", borderTop: "1 solid #a76f1f" }}
                                includeBottomBorder={false}
                                includeTopBorder={false}
                                includeRightBorder={false}
                                includeLeftBorder={false}
                            >
                                <DataTableCell getContent={(r) => intl.formatMessage({ id: r.ItemName })} weighting={0.3}
                                    style={{ fontSize: 12, backgroundColor: "#e1deeb", textAlign: "center", justifyContent: "center", borderWidth: 0, borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }} />
                                <DataTableCell getContent={(r) => r.Value.replaceAll("\r\n", "\n")} style={{ fontSize: 12, backgroundColor: "#f8f7fa", justifyContent: "center", paddingLeft: 10, padding: 5, borderWidth: 0, borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }} />

                            </TableBody>
                        </Table>

                    </View> : null}
                <View style={{
                    width: 90, height: 50, left: 400
                }}><Image src={Stamp} /></View>
                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => {

                    return (
                        `${'01.'} ${intl.formatMessage({ id: "BasicAssessment" })} ${pageNumber} / ${totalPages}`
                    )
                }
                } fixed />
            </Page>
            <Page size="A4" style={styles.page} wrap key={"02"}>
                <PageReference id={'02'} />
                <ContentHeader Profile={Profile} />
                <View style={styles.txtHeader} id={'02'}>
                    <Image src={Header_2} style={styles.imgTitle} ></Image>
                </View>
                <View style={[styles.txtTitle, { paddingLeft: 60 }]} >
                    <Text style={styles.txtNo1}>02</Text>
                    <Text style={styles.txtNo2}>異常清單&建議事項</Text>
                    <Text style={{ fontSize: 10 }}>Abnormality List & Suggestions</Text>
                </View>

                <Text style={[styles.section, { paddingLeft: 60, fontSize: 12, paddingBottom: 0, paddingTop: 0, marginBottom: 0 }]} >
                    {intl.formatMessage({ id: "Abnormality Description" })}
                </Text>
                {Array02.length === 0 ? <View style={[styles.section, { paddingTop: 0 }]} >
                    <Table
                        data={[{ ItemName: "無", Value: "-", Ref: "-", Suggest: "-" }]}
                    >
                        <TableHeader
                            style={{ borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034", border: "2 solid #619034", backgroundColor: "#e1f1d4" }}
                            includeBottomBorder={false}
                            includeTopBorder={false}
                            includeRightBorder={false}
                            includeLeftBorder={false}
                        >
                            <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034", paddingLeft: 10 }} weighting={0.25}  >
                                {intl.formatMessage({ id: "Item" })}
                            </TableCell>
                            <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} weighting={0.2}>
                                {intl.formatMessage({ id: "Value" })}
                            </TableCell>
                            <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} weighting={0.25}>
                                {intl.formatMessage({ id: "Ref." })}
                            </TableCell>
                            <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} weighting={0.3}>
                                {intl.formatMessage({ id: "Suggestion" })}
                            </TableCell>
                        </TableHeader>
                        <TableBody
                            style={{ borderBottom: "1pt solid #a76f1f", borderTop: "1 solid #a76f1f", fontSize: 8 }}
                            includeBottomBorder={false}
                            includeTopBorder={false}
                            includeRightBorder={false}
                            includeLeftBorder={false}
                        >
                            <DataTableCell style={{ fontSize: 12, paddingLeft: 10, backgroundColor: "#f2f8f0", paddingTop: 5, borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }}
                                getContent={r => r.ItemName} weighting={0.25} />
                            <DataTableCell getContent={
                                (r) => (
                                    <Text style={{ color: r.Err === 'true' ? 'red' : '' }}>
                                        {r.Value.replaceAll("\r\n", "\n")}
                                    </Text>
                                )

                            }
                                weighting={0.2}
                                style={{ fontSize: 12, backgroundColor: "#f2f8f0", paddingTop: 5, paddingLeft: 10, padding: 5, borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }}
                            >
                            </DataTableCell>
                            <DataTableCell getContent={(r) => r.Ref} weighting={0.2} style={{ fontSize: 12, backgroundColor: "#f2f8f0", paddingTop: 5, padding: 5, borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} />
                            <DataTableCell getContent={(r) => r.Suggest.replaceAll("\r\n", "\n")} weighting={0.35} style={{ fontSize: 12, backgroundColor: "#f2f8f0", paddingBottom: 5, paddingTop: 5, padding: 5, borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} />
                        </TableBody>
                    </Table>
                </View> : null}
                {
                    ErrArray02_1.length > 0 ?
                        <View style={[styles.section, { paddingTop: 0, paddingBottom: 0, marginBottom: 0 }]} >
                            <Table
                                data={ErrArray02_1}
                            >
                                <TableHeader
                                    style={{ borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034", border: "2 solid #619034", backgroundColor: "#e1f1d4" }}
                                    includeBottomBorder={false}
                                    includeTopBorder={false}
                                    includeRightBorder={false}
                                    includeLeftBorder={false}
                                >
                                    <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034", paddingLeft: 10 }} weighting={0.25}  >
                                        {intl.formatMessage({ id: "Item" })}
                                    </TableCell>
                                    <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} weighting={0.2}>
                                        {intl.formatMessage({ id: "Value" })}
                                    </TableCell>
                                    <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} weighting={0.25}>
                                        {intl.formatMessage({ id: "Ref." })}
                                    </TableCell>
                                    <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} weighting={0.3}>
                                        {intl.formatMessage({ id: "Suggestion" })}
                                    </TableCell>
                                </TableHeader>
                                <TableBody
                                    style={{ borderBottom: "1pt solid #a76f1f", borderTop: "1 solid #a76f1f" }}
                                    includeBottomBorder={false}
                                    includeTopBorder={false}
                                    includeRightBorder={false}
                                    includeLeftBorder={false}
                                >
                                    <DataTableCell getContent={(r) => <Text
                                    // hyphenationCallback={word => [word]}
                                    >{intl.formatMessage({ id: r.ItemName })}</Text>} weighting={0.25} style={{ fontSize: 10, paddingLeft: 10, backgroundColor: "#f2f8f0", paddingTop: 5, borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} />
                                    <DataTableCell getContent={
                                        (r) => (
                                            <Text style={{ color: r.Err === 'true' ? 'red' : '' }}>
                                                {r.Value.replaceAll("\r\n", "\n")}
                                            </Text>
                                        )

                                    }
                                        weighting={0.2}
                                        style={{ fontSize: 10, backgroundColor: "#f2f8f0", paddingTop: 5, paddingLeft: 10, padding: 5, borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }}
                                    >
                                    </DataTableCell>
                                    <DataTableCell getContent={(r) => <Text
                                            // hyphenationCallback={word => [word]}
                                            >{!_.isEmpty(r.Ref) ? intl.formatMessage({ id: r.Ref }): ""}</Text>} weighting={0.2} style={{ fontSize: 10, backgroundColor: "#f2f8f0", paddingTop: 5, padding: 5, borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} />
                                    <DataTableCell getContent={(r) => <Text
                                        // hyphenationCallback={word => [word]}
                                        style={{ wordBreak: 'break-all' }}
                                    >{!_.isEmpty(r.Suggest) ? intl.formatMessage({ id: r.Suggest }).replaceAll("\r\n", "\n") : ""}</Text>}
                                        weighting={0.35} style={{ fontSize: 10, backgroundColor: "#f2f8f0", paddingBottom: 5, paddingTop: 5, padding: 5, borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} />
                                </TableBody>
                            </Table>
                        </View> : null
                }
                {
                    PF.multiFilter(Array02, { ItemNo: ErrItem }).length > 0 ? <View style={[styles.section, { paddingBottom: 0 }]}  >
                        <Table
                            data={PF.multiFilter(Array02, { ItemNo: ErrItem })}
                        >
                            <TableHeader
                                style={{ borderWidth: 0, padding: 10, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034", border: "2 solid #619034", backgroundColor: "#e1f1d4" }}
                                includeBottomBorder={false}
                                includeTopBorder={false}
                                includeRightBorder={false}
                                includeLeftBorder={false}
                            >
                                <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} weighting={0.3}>
                                    {intl.formatMessage({ id: "Item" })}
                                </TableCell>
                                <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} weighting={0.7}>
                                    {intl.formatMessage({ id: "Value" })}
                                </TableCell>
                            </TableHeader>
                            <TableBody
                                style={{ borderBottom: "1pt solid #a76f1f", borderTop: "1 solid #a76f1f" }}
                                includeBottomBorder={false}
                                includeTopBorder={false}
                                includeRightBorder={false}
                                includeLeftBorder={false}
                            >
                                <DataTableCell getContent={(r) => <Text
                                // hyphenationCallback={word => [word]}
                                >{intl.formatMessage({ id: r.ItemName })}</Text>}
                                    weighting={0.3} style={{ fontSize: 10, padding: 5, paddingLeft: 10, backgroundColor: "#f2f8f0", paddingTop: 5, borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} />
                                <DataTableCell getContent={
                                    (r) => (
                                        <Text style={{ color: r.Err === 'true' ? 'red' : '' }}>
                                            {r.Value.replaceAll("\r\n", "\n")}
                                        </Text>
                                    )

                                }
                                    weighting={0.7}
                                    style={{ fontSize: 10, backgroundColor: "#f2f8f0", padding: 5, paddingTop: 5, paddingLeft: 10, borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }}
                                >
                                </DataTableCell>
                            </TableBody>
                        </Table>
                    </View> : null
                }

                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => {
                    return (
                        `${'02.'}${intl.formatMessage({ id: "AbnormalitySuggestions" })} ${pageNumber} / ${totalPages}`
                    )
                }} fixed />
            </Page >
            {
                Array03.length > 0 ?
                    <Page size="A4" style={styles.page} wrap key={"03"}>
                        <PageReference id={'03'} />

                        <ContentHeader Profile={Profile} />
                        <View style={styles.txtHeader} id={'03'}>
                            <Image src={Header_3} style={styles.imgTitle} ></Image>
                        </View>
                        <View style={styles.txtTitle} >
                            <Text style={styles.txtNo1}>0{items.findIndex(x => x.id === '03') + 1}</Text>
                            <Text style={styles.txtNo2}>理學檢查</Text>
                            <Text style={{ fontSize: 10 }}>Physical Examination</Text>
                        </View>

                        <View style={[styles.section, { paddingBottom: 0, marginBottom: 0, paddingTop: 0 }]} >
                            <View style={styles.row} id={"0301"}>
                                <Text>
                                    {intl.formatMessage({ id: "Physique" })}
                                </Text>
                                <View style={styles.line} />
                            </View>
                            <PageReference id={'0301'} />

                            <Table
                                data={PF.multiFilter(Array03, { CheckCategory: ['一般體格'] })}
                            >
                                <TableHeader
                                    style={{ borderWidth: 0, padding: 5 }}
                                    includeBottomBorder={false}
                                    includeTopBorder={false}
                                    includeRightBorder={false}
                                    includeLeftBorder={false}
                                >
                                    <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#d2e6f5", borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }} weighting={0.4} fontSize={12}>
                                        {intl.formatMessage({ id: "Item" })}
                                    </TableCell>
                                    <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#d2e6f5", borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }} weighting={0.2} fontSize={12}>
                                        {intl.formatMessage({ id: "Value" })}
                                    </TableCell>
                                    <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#d2e6f5", borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }} weighting={0.4} fontSize={12}>
                                        {intl.formatMessage({ id: "Ref." })}
                                    </TableCell>

                                </TableHeader>

                                <TableBody
                                    style={{ borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }}
                                    includeBottomBorder={false}
                                    includeTopBorder={false}
                                    includeRightBorder={false}
                                    includeLeftBorder={false}
                                >
                                    <DataTableCell getContent={(r) => <Text
                                    // hyphenationCallback={word => [word]}
                                    >{intl.formatMessage({ id: r.ItemName })}</Text>} weighting={0.4} style={{ padding: 3, fontSize: 10.5, paddingLeft: 10, backgroundColor: "#ebf4fa", justifyContent: "center", borderWidth: 0, borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }} />
                                    <DataTableCell getContent={
                                        (r) => (
                                            <Text style={{ color: r.Err === 'true' ? 'red' : '' }}>
                                                {!_.isEmpty(r.Value) ? intl.formatMessage({ id: r.Value }).replaceAll("\r\n", "\n") : ""}
                                            </Text>
                                        )
                                    }
                                        weighting={0.2}
                                        style={{ padding: 3, fontSize: 10.5, backgroundColor: "#ebf4fa", justifyContent: "center", paddingLeft: 10, padding: 0, borderWidth: 0, borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }}
                                    >
                                    </DataTableCell>
                                    <DataTableCell getContent={(r) => <Text
                                            // hyphenationCallback={word => [word]}
                                            >{!_.isEmpty(r.Ref) ? intl.formatMessage({ id: r.Ref }): ""}</Text>} weighting={0.4} style={{ padding: 3, fontSize: 10.5, backgroundColor: "#ebf4fa", justifyContent: "center", borderWidth: 0, borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }} />

                                </TableBody>
                            </Table>
                        </View>
                        <View style={[styles.section, { paddingBottom: 0 }]} break={true} >
                            <View style={styles.row} id={"0302"}>
                                <Text>
                                    {intl.formatMessage({ id: "DoctorConsultation" })}
                                </Text>
                                <View style={styles.line} />
                            </View>
                            <PageReference id={'0302'} />

                            <Table
                                data={Array03.filter(x => x.Value !== '' && x.CheckCategory === '醫生問診')}
                            >
                                <TableHeader
                                    style={{ borderWidth: 0, padding: 5 }}
                                    includeBottomBorder={false}
                                    includeTopBorder={false}
                                    includeRightBorder={false}
                                    includeLeftBorder={false}
                                >
                                    <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#d2e6f5", borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }} weighting={0.4} fontSize={12}>
                                        {intl.formatMessage({ id: "Item" })}
                                    </TableCell>
                                    <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#d2e6f5", borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }} weighting={0.6} fontSize={12}>
                                        {intl.formatMessage({ id: "Value" })}
                                    </TableCell>


                                </TableHeader>

                                <TableBody
                                    style={{ borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }}
                                    includeBottomBorder={false}
                                    includeTopBorder={false}
                                    includeRightBorder={false}
                                    includeLeftBorder={false}
                                >
                                    <DataTableCell getContent={(r) => <Text
                                    // hyphenationCallback={word => [word]}
                                    >{intl.formatMessage({ id: r.ItemName })}</Text>} weighting={0.4} style={{ padding: 5, fontSize: 10.5, paddingLeft: 10, backgroundColor: "#ebf4fa", justifyContent: "center", borderWidth: 0, borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }} />
                                    <DataTableCell getContent={
                                        (r) => (
                                            <Text style={{ color: r.Err === 'true' ? 'red' : '' }}>
                                                {intl.formatMessage({ id: r.Value }).replaceAll("\r\n", "\n")}
                                            </Text>
                                        )
                                    }
                                        weighting={0.6}
                                        style={{ padding: 5, fontSize: 10.5, backgroundColor: "#ebf4fa", justifyContent: "center", paddingLeft: 10, padding: 0, borderWidth: 0, borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }}
                                    >
                                    </DataTableCell>

                                </TableBody>
                            </Table>
                        </View>
                        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => {
                            let no = items.findIndex(x => x.id === '03');
                            return (
                                `${'0'}${no + 1}${'.'}${intl.formatMessage({ id: '理學檢查' })} ${pageNumber} / ${totalPages}`
                            )
                        }} fixed />
                    </Page> : null
            }
            {
                Array04.length > 0 ? (<Page size="A4" style={styles.page} wrap key={"0004"}>
                    <PageReference id={'04'} />
                    <ContentHeader Profile={Profile} />
                    <View style={styles.txtHeader} id={'04'}>
                        <Image src={Header_4} style={styles.imgTitle} ></Image>
                    </View>
                    <View style={styles.txtTitle} >
                        <Text style={styles.txtNo1}>0{items.findIndex(x => x.id === '04') + 1}</Text>
                        <Text style={styles.txtNo2}>檢驗</Text>
                        <Text style={{ fontSize: 10 }}>Examine</Text>
                    </View>
                    {subItems['04'].map((item, i) => {
                        // console.log(item)
                        return (
                            PF.multiFilter(Array04, { CheckCategory: [item.title2] }).length > 0 ?
                                <View style={[styles.section, { paddingBottom: 0, marginBottom: 0, marginTop: 0 }]} key={i}>
                                    <View style={styles.row} id={item.id2}>
                                        <Text>{item.i18n2}</Text>
                                        <View style={styles.line} />
                                    </View>
                                    <PageReference id={item.id2} />
                                    <Table
                                        // data={PF.multiFilter(Array04, { CheckCategory: [item.title2] })}
                                        data={Array04.filter(x => x.Value !== '' && x.CheckCategory === item.title2)}
                                    >
                                        <TableHeader
                                            style={{ borderWidth: 0, padding: 5 }}
                                            includeBottomBorder={false}
                                            includeTopBorder={false}
                                            includeRightBorder={false}
                                            includeLeftBorder={false}
                                        >
                                            <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1deeb", borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }} weighting={0.3}>
                                                {intl.formatMessage({ id: "Item" })}
                                            </TableCell>
                                            <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1deeb", borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }} weighting={0.3}>
                                                {intl.formatMessage({ id: "Value" })}
                                            </TableCell>
                                            <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#e1deeb", borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }} weighting={0.4}>
                                                {intl.formatMessage({ id: "Ref." })}
                                            </TableCell>
                                        </TableHeader>
                                        <TableBody
                                            style={{ borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }}
                                            includeBottomBorder={false}
                                            includeTopBorder={false}
                                            includeRightBorder={false}
                                            includeLeftBorder={false}
                                        >
                                            <DataTableCell getContent={(r) => <Text
                                            // hyphenationCallback={word => [word]}
                                            >{intl.formatMessage({ id: r.ItemName })}</Text>} weighting={0.3} style={{ fontSize: 10, paddingLeft: 10, backgroundColor: "#f8f7fa", justifyContent: "center", borderWidth: 0, borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }} />
                                            <DataTableCell getContent={
                                                (r) => (
                                                    <Text style={{ color: r.Err === "true" ? 'red' : '' }}>
                                                        {r.Value.replaceAll("\r\n", "\n")}
                                                    </Text>
                                                )
                                            }
                                                weighting={0.3}
                                                style={{ fontSize: 10, backgroundColor: "#f8f7fa", justifyContent: "center", paddingLeft: 10, padding: 5, borderWidth: 0, borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }}
                                            >
                                            </DataTableCell>
                                            <DataTableCell getContent={(r) => <Text
                                            // hyphenationCallback={word => [word]}
                                            >{!_.isEmpty(r.Ref) ? intl.formatMessage({ id: r.Ref }): ""}</Text>} weighting={0.4} style={{ fontSize: 10, backgroundColor: "#f8f7fa", justifyContent: "center", borderWidth: 0, borderBottom: "1pt solid #8a80b0", borderTop: "1 solid #8a80b0" }} />
                                        </TableBody>
                                    </Table>
                                </View> : null)
                    })}
                    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => {
                        let no = items.findIndex(x => x.id === '04');
                        return (
                            `${'0'}${no + 1}${'.'}${intl.formatMessage({ id: '檢驗' })} ${pageNumber} / ${totalPages}`
                        )
                    }} fixed />
                </Page>) : null
            }
            {
                subItems['05'].length > 0 ? <Page size="A4" style={styles.page} wrap key={"0005"}>
                    <PageReference id={'05'} />
                    <ContentHeader Profile={Profile} />
                    <View style={styles.txtHeader} id={'05'}>
                        <Image src={Header_5} style={styles.imgTitle} ></Image>
                    </View>
                    <View style={styles.txtTitle} >
                        <Text style={styles.txtNo1}>0{items.findIndex(x => x.id === '05') + 1}</Text>
                        <Text style={styles.txtNo2}>影像檢查</Text>
                        <Text style={{ fontSize: 10 }}>Image Study</Text>
                    </View>
                    {subItems['05'].map((item, index) => {
                        // console.log(item)
                        return (
                            <>
                                <View key={index} style={[styles.section, { paddingBottom: 0, marginBottom: 0 }]} break={index > 0}>
                                    <View style={styles.row} id={item.id2}>
                                        <Text>{item.i18n2}</Text>
                                        <View style={styles.line} />
                                    </View>
                                </View>

                                <PageReference id={item.id2} />
                                {Array05[item.title2].map((i, no, arr) => {
                                    let previousAry = [null]
                                    if (no > 0) {
                                        const previousItem = arr[no - 1];
                                        // console.log(previousItem.ItemNo, previousItem.ItemName);
                                        // console.log(PicObj["pic_" + previousItem.ItemNo]);
                                        previousAry = PicObj["pic_" + previousItem.ItemNo]?.filter(Boolean);
                                        // console.log(previousCount, "X");

                                    }
                                    // console.log(i.ItemNo, i.ItemName);
                                    // console.log(PicObj["pic_" + i.ItemNo]);
                                    let count = PicObj["pic_" + i.ItemNo]?.filter(Boolean);
                                    // console.log(count, "X");

                                    return (
                                        <>
                                            <View key={no} style={[styles.section, { paddingBottom: 0, marginTop: 0 }]} break={no > 0 && previousAry?.length > 0} >
                                                <View style={[styles.row, { borderLeft: "2pt solid #8a80b0" }]}>
                                                    <Text style={{ paddingLeft: 5 }}>{intl.formatMessage({ id: i.ItemName })}</Text>

                                                </View>
                                                <View style={{ fontSize: 12, paddingTop: 10, paddingBottom: 5 }}>
                                                    <Text>
                                                        {intl.formatMessage({ id: i.ItemNo }) === i.ItemNo ? "" : intl.formatMessage({ id: i.ItemNo })}
                                                    </Text>
                                                </View>

                                                <Table
                                                    data={[{ ItemName: i.ItemName, Value: i.Value, Err: i.Err }]}
                                                >
                                                    <TableHeader
                                                        style={{ borderWidth: 0, padding: 5 }}
                                                        includeBottomBorder={false}
                                                        includeTopBorder={false}
                                                        includeRightBorder={false}
                                                        includeLeftBorder={false}
                                                    >
                                                        <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#d2e6f5", borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }} weighting={0.3}>
                                                            {intl.formatMessage({ id: "Item" })}
                                                        </TableCell>
                                                        <TableCell style={{ borderWidth: 0, padding: 5, backgroundColor: "#d2e6f5", borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }} weighting={0.7}>
                                                            {intl.formatMessage({ id: "Result" })}
                                                        </TableCell>
                                                    </TableHeader>

                                                    <TableBody
                                                        style={{ borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }}
                                                        includeBottomBorder={false}
                                                        includeTopBorder={false}
                                                        includeRightBorder={false}
                                                        includeLeftBorder={false}
                                                    >
                                                        <DataTableCell getContent={(r) => <Text
                                                        // hyphenationCallback={word => [word]}
                                                        >
                                                            {intl.formatMessage({ id: r.ItemName })}
                                                        </Text>} weighting={0.3} style={{ fontSize: 14, paddingLeft: 10, backgroundColor: "#ebf4fa", paddingBottom: 5, paddingTop: 5, borderWidth: 0, borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }} />
                                                        <DataTableCell getContent={
                                                            (r) => (
                                                                <Text style={{ color: r.Err === 'true' ? 'red' : '' }}>
                                                                    {!_.isEmpty(r.Value) ? intl.formatMessage({ id: r.Value }).replaceAll("\r\n", "\n") : ""}
                                                                </Text>
                                                            )
                                                        }
                                                            weighting={0.7}
                                                            style={{ fontSize: 14, backgroundColor: "#ebf4fa", paddingBottom: 5, paddingTop: 5, paddingLeft: 10, borderWidth: 0, borderBottom: "1pt solid #3d93d2", borderTop: "1 solid #3d93d2" }}
                                                        >
                                                        </DataTableCell>

                                                    </TableBody>
                                                </Table>

                                            </View>
                                            {count?.length > 0 ?
                                                <View key={no + "_PIC"} style={[styles.section, { justifyContent: "center", display: 'flex', paddingBottom: 0, paddingTop: 0, marginBottom: 0 }]} break >
                                                    {PicObj["pic_" + i.ItemNo]?.map((img, imgIndex) => {
                                                        // let count = PicObj["pic_" + i.ItemNo].filter(Boolean);  //除去空白
                                                        // if (i.ItemNo === 7029 || i.ItemNo === 7030) {
                                                        //     console.log(count, "pic_" + i.ItemNo)
                                                        // }
                                                        // console.log(i.ItemNo)

                                                        if (i.ItemNo === "7023") {
                                                            return (<View style={[{ height: 330, width: 450, padding: 1, maxHeight: 330, justifyContent: "center", display: "flex", flexDirection: "row", paddingBottom: 0, margin: "auto" }]} key={imgIndex} >
                                                                <Image style={{ width: 450, height: 330, maxHeight: 330 }} src={PF.iisurl2 + "/pictures" + decodeURI(img) + '?Height=330'} />
                                                            </View>)
                                                        } else if (i.ItemNo === "7052") {
                                                            if (imgIndex % 2 === 0) {
                                                                return (
                                                                    <View style={[styles.row, { justifyContent: "center", display: 'flex', paddingBottom: 0 }]} key={imgIndex}>
                                                                        <Image style={{ height: 'auto', width: 170, padding: 2, maxHeight: 350 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex]) + '?Width=800'}></Image>
                                                                        {PicObj["pic_" + i.ItemNo][imgIndex + 1] !== undefined ? <Image style={{ height: 'auto', width: 170, padding: 2, maxHeight: 350 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex + 1]) + '?Width=800'}></Image> : null}
                                                                    </View>)
                                                            }
                                                        } else if (i.ItemNo === "7010" || i.ItemNo === "7012" || i.ItemNo === "7013" || i.ItemNo === "7014" || i.ItemNo === "7015") {
                                                            if (imgIndex % 2 === 0) {
                                                                return (<View style={[styles.row, { justifyContent: "center", display: 'flex', paddingBottom: 0 }]} key={imgIndex} >
                                                                    <Image style={{ height: 'auto', width: 240, padding: 2, maxHeight: 134 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex]) + '?Width=600'}></Image>
                                                                    {PicObj["pic_" + i.ItemNo][imgIndex + 1] !== undefined ? <Image style={{ height: 'auto', width: 240, padding: 2, maxHeight: 134 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex + 1]) + '?Width=600'}></Image> : null}
                                                                </View>)
                                                            }

                                                        } else {
                                                            if (count.length <= 2) {
                                                                // console.log(i.ItemNo)
                                                                return (


                                                                    <View style={{ height: 650, width: 500, justifyContent: "center", display: 'flex', flexDirection: "row", margin: "auto" }} key={imgIndex} >
                                                                        <Image style={{ width: 'auto', height: 'auto', maxHeight: 650, }} src={PF.iisurl2 + "/pictures" + decodeURI(img) + '?Width=1000'} />
                                                                    </View>)
                                                            } else if (count.length > 2 && count.length <= 4) {
                                                                // console.log(decodeURI(img))

                                                                if (i.ItemNo === "7020") {
                                                                    return (
                                                                        <View style={[styles.row, { justifyContent: "center", display: 'flex', paddingBottom: 0, pageBreakAfter: 'always' }]} key={imgIndex} >
                                                                            <Image style={{ height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: 700 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex]) + '?Width=800'}></Image>
                                                                        </View>

                                                                    )
                                                                }
                                                                else {
                                                                    if (imgIndex % 2 === 0) {
                                                                        // 處理其他情况
                                                                        return (
                                                                            <View style={[styles.row, { justifyContent: "center", display: 'flex', paddingBottom: 0 }]} key={imgIndex}>
                                                                                <Image style={{ height: 'auto', width: 250, padding: 2, maxHeight: 345 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex]) + '?Width=800'}></Image>
                                                                                {PicObj["pic_" + i.ItemNo][imgIndex + 1] !== undefined ? (
                                                                                    <Image style={{ height: 'auto', width: 250, padding: 2, maxHeight: 345 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex + 1]) + '?Width=800'}></Image>
                                                                                ) : null}
                                                                            </View>
                                                                        )
                                                                    }
                                                                }





                                                            } else if (count.length > 4) {
                                                                // console.log(decodeURI(img))
                                                                if (imgIndex % 2 === 0) {

                                                                    return (
                                                                        <View style={[styles.row, { justifyContent: "center", display: 'flex', paddingBottom: 0 }]} key={imgIndex} >
                                                                            <Image style={{ height: 'auto', width: 240, padding: 2, maxHeight: 170 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex]) + '?Width=600'}></Image>
                                                                            {PicObj["pic_" + i.ItemNo][imgIndex + 1] !== undefined ? <Image style={{ height: 'auto', width: 240, padding: 2, maxHeight: 170 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex + 1]) + '?Width=600'}></Image> : null}
                                                                        </View>)


                                                                }




                                                            }




                                                        }
                                                        // if (count.length <= 2) {
                                                        //     // console.log(i.ItemNo)
                                                        //     return (

                                                        //         i.ItemNo === "7023" ?
                                                        //             <View style={[{ height: 330, width: 450, padding: 1, maxHeight: 330, justifyContent: "center", display: "flex", flexDirection: "row", paddingBottom: 0, margin: "auto" }]} key={imgIndex} >
                                                        //                 <Image style={{ width: 450, height: 330, maxHeight: 330 }} src={PF.iisurl2 + "/pictures" + decodeURI(img) + '?Height=330'} />
                                                        //             </View>
                                                        //             :
                                                        //             <View style={{ height: 650, width: 500, justifyContent: "center", display: 'flex', flexDirection: "row", margin: "auto" }} key={imgIndex} >
                                                        //                 <Image style={{ width: 'auto', height: 'auto', maxHeight: 650, }} src={PF.iisurl2 + "/pictures" + decodeURI(img) + '?Width=1000'} />
                                                        //             </View>)
                                                        // } else if (count.length > 2 && count.length <= 4) {
                                                        //     // console.log(decodeURI(img))
                                                        //     if (imgIndex % 2 === 0) {
                                                        //         return (

                                                        //             i.ItemNo === "7052" ?
                                                        //                 <View style={[styles.row, { justifyContent: "center", display: 'flex', paddingBottom: 0 }]} key={imgIndex}>
                                                        //                     <Image style={{ height: 'auto', width: 170, padding: 2, maxHeight: 350 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex]) + '?Width=800'}></Image>
                                                        //                     {PicObj["pic_" + i.ItemNo][imgIndex + 1] !== undefined ? <Image style={{ height: 'auto', width: 170, padding: 2, maxHeight: 350 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex + 1]) + '?Width=800'}></Image> : null}
                                                        //                 </View>
                                                        //                 :
                                                        //                 <View style={[styles.row, { justifyContent: "center", display: 'flex', paddingBottom: 0 }]} key={imgIndex}>
                                                        //                     <Image style={{ height: 'auto', width: 250, padding: 2, maxHeight: 345 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex]) + '?Width=800'}></Image>
                                                        //                     {PicObj["pic_" + i.ItemNo][imgIndex + 1] !== undefined ? <Image style={{ height: 'auto', width: 250, padding: 2, maxHeight: 345 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex + 1]) + '?Width=800'}></Image> : null}
                                                        //                 </View>
                                                        //         )

                                                        //     }




                                                        // } else if (count.length > 4) {
                                                        //     // console.log(decodeURI(img))
                                                        //     if (imgIndex % 2 === 0) {
                                                        //         if (i.ItemNo === "7052") //8個一頁
                                                        //             return (

                                                        //                 <View style={[styles.row, { justifyContent: "center", display: 'flex', paddingBottom: 0 }]} key={imgIndex}>
                                                        //                     <Image style={{ height: 'auto', width: 170, padding: 2, maxHeight: 170, }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex]) + '?Width=600'}></Image>
                                                        //                     {PicObj["pic_" + i.ItemNo][imgIndex + 1] !== undefined ? <Image style={{ height: 'auto', width: 170, padding: 2, maxHeight: 170 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex + 1]) + '?Width=600'}></Image> : null}
                                                        //                 </View>)
                                                        //         else if (i.ItemNo === "7010" || i.ItemNo === "7012" || i.ItemNo === "7013" || i.ItemNo === "7014" || i.ItemNo === "7015") {   //10個一頁
                                                        //             return (
                                                        //                 <View style={[styles.row, { justifyContent: "center", display: 'flex', paddingBottom: 0 }]} key={imgIndex} >
                                                        //                     <Image style={{ height: 'auto', width: 240, padding: 2, maxHeight: 134 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex]) + '?Width=600'}></Image>
                                                        //                     {PicObj["pic_" + i.ItemNo][imgIndex + 1] !== undefined ? <Image style={{ height: 'auto', width: 240, padding: 2, maxHeight: 134 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex + 1]) + '?Width=600'}></Image> : null}
                                                        //                 </View>)
                                                        //         }
                                                        //         else {
                                                        //             return (
                                                        //                 <View style={[styles.row, { justifyContent: "center", display: 'flex', paddingBottom: 0 }]} key={imgIndex} >
                                                        //                     <Image style={{ height: 'auto', width: 240, padding: 2, maxHeight: 170 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex]) + '?Width=600'}></Image>
                                                        //                     {PicObj["pic_" + i.ItemNo][imgIndex + 1] !== undefined ? <Image style={{ height: 'auto', width: 240, padding: 2, maxHeight: 170 }} src={PF.iisurl2 + "/pictures" + decodeURI(PicObj["pic_" + i.ItemNo][imgIndex + 1]) + '?Width=600'}></Image> : null}
                                                        //                 </View>)
                                                        //         }

                                                        //     }




                                                        // }



                                                    })}

                                                </View> : null}

                                        </>
                                    )
                                })}


                            </>
                        )


                    })}

                    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => {
                        let no = items.findIndex(x => x.id === '05');
                        return (
                            `${'0'}${no + 1}${'.'}${intl.formatMessage({ id: '影像檢查' })} ${pageNumber} / ${totalPages}`
                        )
                    }} fixed />
                </Page >
                    : null
            }

            {
                Array06.length > 0 ?
                    <Page size="A4" style={styles.page} wrap key={"0006"}>
                        <PageReference id={'06'} />
                        <ContentHeader Profile={Profile} />
                        <View style={styles.txtHeader} id={'06'}>
                            <Image src={Header_2} style={styles.imgTitle} ></Image>
                        </View>
                        <View style={styles.txtTitle} key={'0600'}>
                            <Text style={styles.txtNo1}>0{items.findIndex(x => x.id === '06') + 1}</Text>
                            <Text style={styles.txtNo2}>其他檢查</Text>
                            <Text style={{ fontSize: 10 }}>Other Examination</Text>
                        </View>
                        {subItems['06'].map((item, index) => {
                            // let object = _.keyBy(Array06, 'CheckCategory');
                            // console.log(object)

                            return (PF.multiFilter(Array06, { CheckCategory: [item.title2] }).length > 0 ?
                                <View style={styles.section} break={index === 0 ? false : true} key={index}>
                                    <View style={{ padding: 10, paddingLeft: 0 }} id={item.id2} key={item.id2} >
                                        <PageReference id={item.id2} />
                                        <View style={styles.row} >
                                            <Text style={{ fontWeight: "bold" }}>{item.i18n2}</Text>
                                            <View style={styles.line} />
                                        </View>
                                    </View>
                                    <Text style={{ fontSize: 12, paddingBottom: 5 }}>
                                        {intl.formatMessage({ id: item.id2 })}
                                    </Text>
                                    <Table
                                        data={PF.multiFilter(Array06, { CheckCategory: [item.title2] })}
                                    >
                                        <TableHeader
                                            style={{ borderWidth: 0, padding: 10, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034", border: "2 solid #619034", backgroundColor: "#e1f1d4" }}
                                            includeBottomBorder={false}
                                            includeTopBorder={false}
                                            includeRightBorder={false}
                                            includeLeftBorder={false}
                                        >
                                            <TableCell style={{ borderWidth: 0, padding: 10, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} weighting={0.3}>
                                                {intl.formatMessage({ id: "Item" })}
                                            </TableCell>
                                            <TableCell style={{ borderWidth: 0, padding: 10, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} weighting={0.3}>
                                                {intl.formatMessage({ id: "Value" })}
                                            </TableCell>
                                            <TableCell style={{ borderWidth: 0, padding: 10, backgroundColor: "#e1f1d4", borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} weighting={0.4}>
                                                {intl.formatMessage({ id: "Ref." })}
                                            </TableCell>

                                        </TableHeader>
                                        <TableBody
                                            style={{ borderBottom: "1pt solid #a76f1f", borderTop: "1 solid #a76f1f" }}
                                            includeBottomBorder={false}
                                            includeTopBorder={false}
                                            includeRightBorder={false}
                                            includeLeftBorder={false}
                                        >
                                            <DataTableCell getContent={(r) => <Text
                                            // hyphenationCallback={word => [word]}
                                            >{intl.formatMessage({ id: r.ItemName })}</Text>} weighting={0.3} style={{ fontSize: 14, paddingLeft: 10, backgroundColor: "#f2f8f0", justifyContent: "center", borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} />
                                            <DataTableCell getContent={
                                                (r) => (
                                                    <Text style={{ color: r.Err === "true" ? 'red' : '' }}>
                                                        {r.Value.replaceAll("\r\n", "\n")}
                                                    </Text>
                                                )

                                            }
                                                weighting={0.3}
                                                style={{ fontSize: 14, backgroundColor: "#f2f8f0", justifyContent: "center", paddingLeft: 10, padding: 10, borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }}
                                            >
                                            </DataTableCell>
                                            <DataTableCell getContent={(r) => <Text
                                            // hyphenationCallback={word => [word]}
                                            >{!_.isEmpty(r.Ref) ? intl.formatMessage({ id: r.Ref }): ""}</Text>} weighting={0.4} style={{ fontSize: 14, backgroundColor: "#f2f8f0", justifyContent: "center", borderWidth: 0, borderBottom: "1pt solid #619034", borderTop: "1 solid #619034" }} />
                                            

                                        </TableBody>
                                    </Table>
                                </View>
                                : null)

                        })}


                        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => {
                            let no = items.findIndex(x => x.id === '06');
                            return (
                                `${'0'}${no + 1}${'.'}${intl.formatMessage({ id: "其他檢查" })} ${pageNumber} / ${totalPages}`
                            )
                        }} fixed />
                    </Page >
                    : null
            }

        </ >

    )
};



const App = (props) => {
    // const items = genItems(50);
    const { Array02, items, Profile, Array03, Array04, Array06, GaugeItem, PicObj, Array02_1, Array02_2, subItems, i18n } = props;
    // const getBarcodeGaugeItem = (BarCodeStr) => {
    //     PF.instance({
    //         method: "post",
    //         url: PF.url2 + "/Minmax/GetGaugeData",
    //         data: Qs.stringify({ Action: "none", parameter: { BarCodeStr } })
    //         // headers: { token: sessionStorage.token }
    //     })
    //         .then(function (response) {
    //             // alert("完成")
    //             const { TotalRecord, rows } = response.data;
    //             if (TotalRecord > 0) {
    //                 // console.log(rows);
    //                 let ContentJson = JSON.parse(rows[0]["content"]);
    //                 // console.log(ContentJson);
    //                 setArray03(PF.multiFilter(ContentJson, { CheckCategory: ['一般體格', '醫生問診'] }))

    //                 setArray06(PF.multiFilter(ContentJson, { CheckCategory: ['肺功能檢查'] }))
    //                 setArray02_1(PF.multiFilter(ContentJson, { Err: ['true'] }))

    //                 // setArray02(prev => [...Array02, ...PF.multiFilter(ContentJson, { Err: ['true'] })])
    //                 // arr02 = [...arr02, ...PF.multiFilter(ContentJson, { Err: ['true'] })]

    //                 // let Array03 = PF.multiFilter(ContentJson, { CheckCategory: ['醫生問診'] });
    //                 // console.log(ContentJson);
    //                 // console.log(PF.multiFilter(ContentJson, { Err: ['true'] }))

    //                 let ItemArray = PF.multiFilter(ContentJson, { CheckCategory: PicCategoryArray });
    //                 // console.log(ItemArray);
    //                 let object = _.keyBy(ItemArray, 'CheckCategory');
    //                 // console.log(object);
    //                 let y = {}
    //                 Object.keys(object).map(CheckCategory => {
    //                     y[CheckCategory] = PF.multiFilter(ContentJson, { CheckCategory: CheckCategory })
    //                 })
    //                 // console.log(y);
    //                 setGaugeItem(y)
    //             }
    //             else {
    //             }
    //         })
    // }
    // const getBarcodeLabItem = (BarCodeStr) => {
    //     PF.instance({
    //         method: "post",
    //         url: PF.url2 + "/Minmax/GetLabData",
    //         data: Qs.stringify({ Action: "none", parameter: { BarCodeStr } })
    //         // headers: { token: sessionStorage.token }
    //     })
    //         .then(function (response) {
    //             // alert("完成")
    //             const { TotalRecord, rows } = response.data;
    //             if (TotalRecord > 0) {
    //                 // console.log(rows);
    //                 let ContentJson = JSON.parse(rows[0]["content"]);
    //                 // console.log(PF.multiFilter(ContentJson, { Err: ['true'] }))
    //                 setArray02(prev => [...Array02, ...PF.multiFilter(ContentJson, { Err: ['true'] })])
    //                 // setArray02(prev => prev.concat(PF.multiFilter(ContentJson, { Err: ['true'] })))
    //                 setArray02_2(PF.multiFilter(ContentJson, { Err: ['true'] }))

    //                 // console.log(ContentJson);
    //                 setArray04(ContentJson)
    //             }
    //             else {
    //             }
    //         })
    // }
    // const getBarcode = (qc_id) => {
    //     PF.instance({
    //         method: "post",
    //         url: PF.url2 + "/Minmax/QueryBarcode",
    //         data: Qs.stringify({ Action: "none", parameter: { qc_id } })
    //         // headers: { token: sessionStorage.token }
    //     })
    //         .then(function (response) {
    //             // alert("完成")
    //             const { TotalRecord, rows } = response.data;
    //             if (TotalRecord > 0) {
    //                 const people = rows[0]
    //                 // console.log(rows);
    //                 setProfile({
    //                     age: people.age,
    //                     PersonalId: people.PersonalId,
    //                     UserName: people.UserName,
    //                     sogi: people.sogi,
    //                     checkdate: people.checkdate,
    //                     chart: people.chart,
    //                     barcode: people.barcode,
    //                     sex: people.sex || ' 男',
    //                     birthday: people.birthday || '1900/01/01'
    //                 })
    //                 //解析圖片為JSON物件
    //                 let PicJson = JSON.parse(rows[0]["pic"]);
    //                 // console.log(PicJson);

    //                 Object.keys(PicJson || {}).map(pic => {
    //                     // console.log(pic)
    //                     setPicObj(prev => ({
    //                         ...prev,
    //                         [pic]: PicJson[pic]?.split(',') || []
    //                     }))
    //                 });


    //             }
    //             else {
    //             }
    //         })
    // }
    // const getFullData = (BarCodeStr) => {
    //     PF.instance({
    //         method: "post",
    //         url: PF.url2 + "/Minmax/GetFullData",
    //         data: Qs.stringify({ Action: "none", parameter: { BarCodeStr } })
    //         // headers: { token: sessionStorage.token }
    //     })
    //         .then(function (response) {
    //             // alert("完成")
    //             const { TotalRecord, Profile, LabData, GaugeData } = response.data;
    //             if (TotalRecord > 0) {
    //                 const people = Profile[0]
    //                 // console.log(rows);
    //                 setProfile({
    //                     age: people.age,
    //                     PersonalId: people.PersonalId,
    //                     UserName: people.UserName,
    //                     sogi: people.sogi,
    //                     checkdate: people.checkdate,
    //                     chart: people.chart,
    //                     barcode: people.barcode,
    //                     sex: people.sex || ' 男',
    //                     birthday: people.birthday || '1900/01/01'
    //                 })
    //                 //解析圖片為JSON物件
    //                 let PicJson = JSON.parse(Profile[0]["pic"]);
    //                 // console.log(PicJson);

    //                 Object.keys(PicJson || {}).map(pic => {
    //                     // console.log(pic)
    //                     setPicObj(prev => ({
    //                         ...prev,
    //                         [pic]: PicJson[pic]?.split(',') || []
    //                     }))
    //                 });
    //                 //Lab
    //                 let ContentJson = JSON.parse(LabData[0]["content"]);
    //                 // console.log(PF.multiFilter(ContentJson, { Err: ['true'] }))
    //                 setArray02(prev => [...prev, ...ContentJson.filter(x => x.Err === 'true')])
    //                 // setArray02(prev => prev.concat(PF.multiFilter(ContentJson, { Err: ['true'] })))
    //                 setArray02_2(PF.multiFilter(ContentJson, { Err: ['true'] }))

    //                 // console.log(ContentJson);
    //                 setArray04(ContentJson)

    //                 if (ContentJson.length > 0) {
    //                     setitems(prev => [...prev, { id: '04', title: ' - 檢驗', data: ContentJson }])
    //                 }
    //                 //Gauge


    //                 let ContentJson2 = JSON.parse(GaugeData[0]["content"]);
    //                 // console.log(ContentJson);
    //                 setArray03(PF.multiFilter(ContentJson2, { CheckCategory: ['一般體格', '醫生問診'] }))
    //                 // setArray02_1(PF.multiFilter(ContentJson2, { Err: ['true'] }))
    //                 setArray02(prev => [...prev, ...ContentJson2.filter(x => x.Err === 'true')])

    //                 // setArray02(prev => [...Array02, ...PF.multiFilter(ContentJson, { Err: ['true'] })])
    //                 // arr02 = [...arr02, ...PF.multiFilter(ContentJson, { Err: ['true'] })]

    //                 // let Array03 = PF.multiFilter(ContentJson, { CheckCategory: ['醫生問診'] });
    //                 // console.log(ContentJson);
    //                 // console.log(PF.multiFilter(ContentJson, { Err: ['true'] }))

    //                 let ItemArray = PF.multiFilter(ContentJson2, { CheckCategory: PicCategoryArray });
    //                 // console.log(ItemArray);
    //                 let object = _.keyBy(ItemArray, 'CheckCategory');
    //                 // console.log(object);
    //                 let y = {}
    //                 Object.keys(object).map(CheckCategory => {
    //                     y[CheckCategory] = PF.multiFilter(ContentJson2, { CheckCategory: CheckCategory })
    //                 })
    //                 // console.log(y);
    //                 setGaugeItem(y)
    //                 if (Object.keys(y).length > 0) {
    //                     setitems(prev => [...prev, { id: '05', title: ' - 影像檢查', data: y }])

    //                 }
    //                 let array6 = PF.multiFilter(ContentJson2, { CheckCategory: ['肺功能檢查'] })
    //                 setArray06(array6)

    //                 if (array6.length > 0) {
    //                     setitems(prev => [...prev, { id: '06', title: ' - 其他檢查', data: array6 }])
    //                 }





    //             }
    //             else {
    //             }
    //         })
    // }

    // useEffect(() => {
    //     // getBarcode('51004');
    //     // getBarcodeGaugeItem('2200046510');
    //     // getBarcodeLabItem('2200046510');
    //     getFullData('2200046510');
    // }, [])


    let overviewChart = {
        A1: Array02.filter(x => x.system_name === '神經系統'),
        A2: Array02.filter(x => x.system_name === '一般體格'),
        B1: Array02.filter(x => x.system_name === '頭頸部與心血管系統'),
        B2: Array02.filter(x => x.system_name === '血液'),
        C1: Array02.filter(x => x.system_name === '胸腔與呼吸系統'),
        C2: Array02.filter(x => x.system_name === '免疫系統'),
        D1: Array02.filter(x => x.system_name === '腹部與肝膽腸胃系統'),
        D2: Array02.filter(x => x.system_name === '重金屬檢查'),
        E1: Array02.filter(x => x.system_name === '泌尿生殖系統'),
        E2: Array02.filter(x => x.system_name === '基因檢查'),
        F1: Array02.filter(x => x.system_name === '肌肉骨骼系統'),
        F2: Array02.filter(x => x.system_name === '新陳代謝'),
        G2: Array02.filter(x => x.system_name === '醫生問診'),

    }
    const intl = useIntl();
    const imageMap = {
        'zh-tw': FistPageTW,  // 繁體中文第一頁
        'en': FistPageEN,     // 英文第一頁
        'ja': FistPageTW,     // 日文第一頁
    };
    const lastPageMap = {
        'zh-tw': LastPageTW,  // 繁體中文最後一頁
        'en': LastPageEN,     // 英文最後一頁
        'ja': LastPageTW,     // 日文最後一頁
    };
    Font.registerHyphenationCallback((word) => {
        if (i18n.locale === 'zh-tw') {
            let a = Array.from(word).flatMap((char) => [char, ''])
            return a
        } else {
            return word.length <= 20 ? [word] : Array.from(word).map(char => char)
        }
    }
    )
    // const dispatch = useDispatch();
    return (
        <Document
        >
            <ProvidePageReferences>
                <Page size="A4" key={"FistPage"}>
                    <Image src={imageMap[i18n.locale] || FistPageTW}
                        style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            objectFit: 'fill',
                        }}></Image>
                </Page>
                {/* <Page size="A4" style={styles.page}>
                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>神經系統</Text>
                                <View style={styles.line} />
                            </View>
                            <Text>0項異常</Text>

                        </View>
                        <View style={styles.txtOverView2}>
                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>一般體格</Text>
                            </View>
                            <Text>0項異常</Text>

                        </View>
                    </View>
                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>頭頸部與心血管系統</Text>
                                <View style={styles.line} />
                            </View>
                            <Text>0項異常</Text>

                        </View>
                        <View style={styles.txtOverView2}>


                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>血液</Text>
                            </View>
                            <Text>0項異常</Text>

                        </View>
                    </View>
                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>胸腔與呼吸系統</Text>
                                <View style={styles.line} />
                            </View>
                            <Text>0項異常</Text>

                        </View>
                        <View style={styles.txtOverView2}>


                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>免疫系統</Text>
                            </View>
                            <Text>0項異常</Text>

                        </View>
                    </View>
                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>腹部與肝膽腸胃系統</Text>
                                <View style={styles.line} />
                            </View>
                            <Text>0項異常</Text>

                        </View>
                        <View style={styles.txtOverView2}>


                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>重金屬檢查</Text>
                            </View>
                            <Text>0項異常</Text>

                        </View>
                    </View>

                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>泌尿生殖系統
                                </Text>
                                <View style={styles.line} />
                            </View>
                            <Text>0項異常</Text>

                        </View>
                        <View style={styles.txtOverView2}>


                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>基因檢查
                                </Text>
                            </View>
                            <Text>0項異常</Text>

                        </View>
                    </View>
                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>肌肉骨骼系統

                                </Text>
                                <View style={styles.line} />
                            </View>
                            <Text>0項異常</Text>

                        </View>
                        <View style={styles.txtOverView2}>


                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>新陳代謝

                                </Text>
                            </View>
                            <Text>0項異常</Text>

                        </View>
                    </View>

                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>

                                </Text>
                            </View>
                            <Text></Text>

                        </View>
                        <View style={styles.txtOverView2}>


                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 700 }]}>
                                <Text>醫生問診</Text>
                            </View>
                            <Text>0項異常</Text>

                        </View>
                    </View>
                </Page> */}
                <Page size="A4" style={styles.page2} key={"Overview"}>
                    <View style={[styles.section,]}>

                        <View style={{
                            display: 'flex',
                            flexDirection: "row",
                            justifyContent: "center",
                        }}>
                            <View style={{ padding: 20, width: 210, fontWeight: 900, textAlign: 'center' }}>
                                <Text style={{ fontSize: 15 }} >系統總覽</Text>
                                <Text style={{ fontSize: 12, wordBreak: 'break-word' }} >{intl.formatMessage({ id: "System Overview" })}</Text>
                            </View>

                            <View style={{
                                width: 600, justifyContent: "center", height: 80, padding: 10,
                            }}>
                                <Text style={{ fontSize: 12, paddingLeft: 10, borderLeft: "1pt solid #8a80b0" }}>{intl.formatMessage({ id: "System Overview Description" })}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.section, {
                        backgroundColor: "#F8F8F8", justifyContent: "center", display: 'flex', flexDirection: "row", borderRadius: 10,
                        position: 'absolute', zIndex: -1, top: 100, width: '96vw'

                    }]}>
                        <Image style={{ width: 230, height: 550, paddingTop: 30 }} src={Males} />
                    </View>
                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                        paddingTop: 30
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "神經系統" })}</Text>
                                <View style={styles.line} />
                            </View>
                            {overviewChart.A1.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.A1.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}

                        </View>
                        <View style={styles.txtOverView2}>
                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "一般體格" })}</Text>
                            </View>
                            {overviewChart.A2.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.A2.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}
                        </View>
                    </View>
                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "頭頸部與心血管系統" })}</Text>
                                <View style={styles.line} />
                            </View>
                            {overviewChart.B1.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.B1.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}
                        </View>
                        <View style={styles.txtOverView2}>


                        </View>
                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "血液" })}</Text>
                            </View>
                            {overviewChart.B2.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.B2.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}
                        </View>
                    </View>
                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "胸腔與呼吸系統" })}</Text>
                                <View style={styles.line} />
                            </View>
                            {overviewChart.C1.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.C1.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}
                        </View>
                        <View style={styles.txtOverView2}>


                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "免疫系統" })}</Text>
                            </View>
                            {overviewChart.C2.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.C2.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}
                        </View>
                    </View>
                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "腹部與肝膽腸胃系統" })}</Text>
                                <View style={styles.line} />
                            </View>
                            {overviewChart.D1.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.D1.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}
                        </View>
                        <View style={styles.txtOverView2}>


                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "重金屬檢查" })}</Text>
                            </View>
                            {overviewChart.D2.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.D2.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}
                        </View>
                    </View>

                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                        paddingTop: 30
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "泌尿生殖系統" })}
                                </Text>
                                <View style={styles.line} />
                            </View>
                            {overviewChart.E1.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.E1.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}
                        </View>
                        <View style={styles.txtOverView2}>


                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "基因檢查" })}</Text>
                            </View>
                            {overviewChart.E2.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.E2.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}
                        </View>
                    </View>
                    <View style={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "肌肉骨骼系統" })}</Text>
                            </View>
                            {overviewChart.F1.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.F1.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}

                        </View>
                        <View style={styles.txtOverView2}>


                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "新陳代謝" })}</Text>
                            </View>
                            {overviewChart.F2.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.F2.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}

                        </View>
                    </View>
                    <View style={{
                        flexDirection: "row",
                        justifyContent: "center",
                    }}>

                        <View style={styles.txtOverView}>
                            <View style={[styles.row, { fontWeight: 0 }]}>

                            </View>


                        </View>
                        <View style={styles.txtOverView2}>


                        </View>

                        <View style={styles.txtOverView3}>
                            <View style={[styles.row, { fontWeight: 0 }]}>
                                <Text>{intl.formatMessage({ id: "醫生問診" })}</Text>
                            </View>
                            {overviewChart.G2.length > 0 ? (<Text style={{ color: '' }}>{overviewChart.G2.length}{" "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            ) : (<Text>{"0 "}{intl.formatMessage({ id: "abnormality" })}</Text>
                            )}
                        </View>
                    </View>
                </Page>
                {/* <Page size="A4" style={styles.page} wrap>
                    <View style={styles.section}>
                        <View style={styles.row}>

                            <Image style={{ width: 250, height: 200, padding: 1 }} src={"http://mj.mornjoy.com.tw/Examinenetcore/pictures/Content/Upload/images/111.5/0508/L123532327_賴冠宏/page-1.jpg"}></Image>
                            <Image style={{ width: 250, height: 200, padding: 1 }} src={"http://mj.mornjoy.com.tw/Examinenetcore/pictures/Content/Upload/images/111.5/0508/L123532327_賴冠宏/page-1.jpg"}></Image>
                        </View>
                        <View style={styles.row}>

                            <Image style={{ width: 250, height: 200, padding: 1 }} src={"http://mj.mornjoy.com.tw/Examinenetcore/pictures/Content/Upload/images/111.5/0508/L123532327_賴冠宏/page-1.jpg"}></Image>
                            <Image style={{ width: 250, height: 200, padding: 1 }} src={"http://mj.mornjoy.com.tw/Examinenetcore/pictures/Content/Upload/images/111.5/0508/L123532327_賴冠宏/page-1.jpg"}></Image>
                        </View>

                    </View>
                </Page> */}
                <Page size="A4" style={styles.page2} key={"TOC"}>
                    <View style={[styles.section, { marginBottom: 0 }]} >
                        <Text style={{ fontSize: 30, borderBottom: '5 solid #dcdcdc', padding: 10 }}>{intl.formatMessage({ id: "Content" })}</Text>
                    </View>
                    <Toc items={items} subItems={subItems} />
                </Page>
                {/* <Page size="A4" style={styles.page}>
                    {items.map((item, index) => {
                        return (
                            <ItemContent
                                key={index}
                                item={item}
                                break={newPage(0.2)}
                            />
                        );
                    })}
                </Page> */}
                <MyDocument items={items} Profile={Profile} Array03={Array03} Array04={Array04} Array06={Array06} Array05={GaugeItem} PicObj={PicObj} Array02={[...Array02_1, ...Array02_2]} subItems={subItems} />
                <Page size="A4" key={"LastPage"}>
                <Image 
                    src={lastPageMap[i18n.locale] || LastPageTW}  // 預設值
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        objectFit: 'fill',
                    }} 
                />
            </Page>
            </ProvidePageReferences>
        </Document >
    )
};



export default App;